import React from 'react';
import { SmBadge } from '@smiles/smiles-react-design-system';

type TProps = React.HTMLProps<HTMLElement> & {
  text: string;
  variant?: 'neutral' | 'primary' | 'success' | 'error' | 'warning' | 'club';
};

export function Badge({ text, className, variant }: TProps) {
  return <SmBadge text={text} className={className} variant={variant} />;
}
